module.exports = __webpack_public_path__ + "static/media/hacker_rank_logo.1a137090.webp";